import { useFormContext, useWatch } from 'react-hook-form';

import { FieldVisibilityProps } from '../../types/FieldVisibilityProps';

export const useIsFieldVisible = (field: FieldVisibilityProps['field']) => {
  const { conditionalVisibility } = field.meta;
  const { control } = useFormContext();
  const watchedValue = useWatch({
    control,
    name: conditionalVisibility.dependsOn,
  });

  if ('values' in conditionalVisibility) {
    return conditionalVisibility.values.includes(watchedValue);
  }

  return watchedValue === conditionalVisibility.value;
};
